import { MechanicRewardTypesEnum, MechanicStepDefaultValuesType, MechanicStepType } from 'entities/mechanic/model';
import TableCell from '@mui/material/TableCell';
import React from 'react';
import { IconButton, TableRow } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { PrizeType } from 'entities/prize';

type MechanicStepTableNoEditedTextRowPropsType = {
  editableRow: number | null;
  row: MechanicStepType;
  defaultValues: MechanicStepDefaultValuesType;
  removeItem: (idx: number) => void;
  editItem: (idx: number) => void;
  prizeData: PrizeType[];
  CF3_target: boolean;
  CF4_target: boolean;
  CF6_target: boolean;
};

export const MechanicStepTableNoEditedTextRow = ({
  row,
  defaultValues,
  editableRow,
  removeItem,
  editItem,
  prizeData,
  CF3_target,
  CF4_target,
  CF6_target,
}: MechanicStepTableNoEditedTextRowPropsType) => {
  const selectedPrize = prizeData.find((option) => option.prize_type_id === row.reward);
  return (
    <TableRow>
      <TableCell sx={{ width: 100 }}>{defaultValues.target?.visibleValue || `${row.target || ''}`}</TableCell>
      {row.reward_type && <TableCell sx={{ width: 100 }}>{`${row.reward_type}`}</TableCell>}
      {CF6_target || ((CF3_target || CF4_target) && row.reward_type === MechanicRewardTypesEnum.PRIZE) ? (
        <TableCell sx={{ width: 100 }}>{selectedPrize?.name.ru}</TableCell>
      ) : (
        <TableCell sx={{ width: 100 }}>{defaultValues.reward?.visibleValue || `${row.reward || ''}`}</TableCell>
      )}
      <TableCell>
        <IconButton
          disabled={editableRow !== null}
          onClick={() => editItem(row.id)}
        >
          <EditOutlinedIcon />
        </IconButton>
        <IconButton
          disabled={editableRow !== null}
          onClick={() => removeItem(row.id)}
        >
          <CloseOutlinedIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};
